import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createNotice } from '../../../api/boardNotice.api';
import Editor from '../../../components/board/notice/Editor';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';

const BoardNoticeCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/board/notice');
    }
  }, [res, isLoading]);

  const submit = (data: FormData) => {
    execute(createNotice(data));
  };

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-board-big.svg"
        parentMenu={t('common.menu.board')}
        currentMenu={t('board.notice.title8')}
      />
      <Editor onSubmit={submit} />
    </div>
  );
};

export default BoardNoticeCreate;
